import React from 'react';
import { useStacklineTheme } from '@stackline/ui';
import SlSkeleton from 'src/components/BeaconV2Components/SlSkeleton/SlSkeleton';
import Flex from 'src/components/BeaconV2Components/Flex/Flex';

/**
 * ProductReviewCardLoadingV2 Component
 *
 * Loading Skeleton For ProductReviewCardV2
 */
const ProductReviewCardLoadingV2 = () => {
  const theme = useStacklineTheme();

  return (
    <Flex
      flexDirection="column"
      style={{
        width: '512px',
        height: '560px',
        padding: `24px 16px 20px 16px`,
        borderRadius: '12px',
        border: `1px solid ${theme.colors.primaryGray}`
      }}
    >
      <Flex flexDirection="column">
        {/* Image, Brand and Product Name */}
        <Flex>
          {/* Image */}
          <SlSkeleton variant="rounded" height={80} width={80} />

          {/* Brand Name Product Name */}
          <Flex style={{ marginLeft: '16px' }} flexDirection="column">
            <SlSkeleton height={24} width={64} variant="rounded" />
            <Flex style={{ marginTop: '8px' }}>
              <SlSkeleton height={40} width={384} variant="rounded" />
            </Flex>
          </Flex>
        </Flex>

        {/* Stars, Date, Customer and Review */}
        <Flex style={{ marginTop: 16 }}>
          <SlSkeleton height={152} width={480} variant="rounded" />
        </Flex>

        {/* QUALITY SCORE AND SENTIMENT TAG */}
        <Flex style={{ marginTop: 12 }}>
          <SlSkeleton height="224px" width="480px" variant="rounded" />
        </Flex>

        {/* Bottom View More */}
        <Flex marginTop={{ marginTop: 16 }}>
          <SlSkeleton height="16px" width="86px" variant="rounded" />
        </Flex>
      </Flex>
    </Flex>
  );
};

export default ProductReviewCardLoadingV2;
